import React, { useRef } from "react";
import Autocomplete from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import { InputField } from '../formElements';
import RichTextEditor from "../richTextEditor/textEditor";

const EmailComposer = ({
  textProps,
  todata,
  setToData,
  inputValue,
  setInputValue,
  getSuggestions,
  ccData,
  setCcData,
  ccInputValue,
  setCcInputValue,
  setUsersValue,
  setCcUsersValue,
  subject,
  setSubject,
  content,
  setContent,
  attachments,
  handleFileChange,
  removeAttachment,
  download,
  sendInvite,
}) => {
  const editor = useRef(null);
  return (
    <form>
      <div className="card">
        <div className="card-body">
          <div className="row">
            <div className="col-md-12 emailcompose">
              <InputField
                {...textProps}
                name="fromtext"
                must={"true"}
                type="text"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <div style={{ color: "#C0C0C0" }} className="font14">From</div>
                    </InputAdornment>
                  ),
                }}
              />

              <div style={{ paddingTop: "30px" }}>
                <Autocomplete
                  multiple
                  limitTags={2}
                  id="multiple-limit-tags"
                  value={todata}
                  options={getSuggestions(inputValue)}
                  inputValue={inputValue}
                  onInputChange={(e, newVal) => setInputValue(newVal)}
                  getOptionLabel={(option) =>
                    typeof option === "string" ? option : option.label
                  }
                  isOptionEqualToValue={(option, value) => option.value === value.value}
                  onChange={(event, value) => {
                    const uniqueValues = value.filter(
                      (v, i, self) => i === self.findIndex((o) => o.value === v.value)
                    );
                    setUsersValue(uniqueValues);
                    setToData(uniqueValues);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="standard"
                      placeholder=""
                      InputProps={{
                        ...params.InputProps,
                        startAdornment: (
                          <>
                            <InputAdornment position="start">
                              <div style={{ color: "#C0C0C0" }} className="font14">To</div>
                            </InputAdornment>
                            {params.InputProps.startAdornment}
                          </>
                        ),
                      }}
                    />
                  )}
                />
              </div>

              <div style={{ paddingTop: "30px" }}>
                <Autocomplete
                  multiple
                  limitTags={2}
                  id="multiple-cc-tags"
                  value={ccData}
                  options={getSuggestions(ccInputValue)}
                  inputValue={ccInputValue}
                  onInputChange={(e, val) => setCcInputValue(val)}
                  getOptionLabel={(option) =>
                    typeof option === "string" ? option : option.label
                  }
                  isOptionEqualToValue={(option, value) => option.value === value.value}
                  onChange={(event, value) => {
                    const uniqueValues = value.filter(
                      (v, i, self) => i === self.findIndex((o) => o.value === v.value)
                    );
                    setCcUsersValue(uniqueValues);
                    setCcData(uniqueValues);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="standard"
                      placeholder=""
                      InputProps={{
                        ...params.InputProps,
                        startAdornment: (
                          <>
                            <InputAdornment position="start">
                              <div style={{ color: "#C0C0C0" }} className="font14">Cc</div>
                            </InputAdornment>
                            {params.InputProps.startAdornment}
                          </>
                        ),
                      }}
                    />
                  )}
                />
              </div>
              <div style={{ paddingTop: "30px" }}>
                <InputField
                  {...textProps}
                  name="ipSubject"
                  value={subject || ""}
                  must={"false"}
                  type="text"
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <div style={{ color: "#C0C0C0" }} className="font14">Subject</div>
                      </InputAdornment>
                    ),
                  }}
                />
              </div>

              <br />
              <RichTextEditor
                ref={editor}
                value={content}
                onChange={(newContent) => setContent(newContent)}
              />

              {attachments.length > 0 && (
                <div className="" style={{ display: 'flex', flexWrap: 'wrap', marginTop: '5px' }}>
                  {attachments.map((file, index) => (
                    <div
                      key={index}
                      className="flex flex-row items-center bg-gray-100 px-2 py-1 rounded text-sm"
                    >
                      <a
                        href=""
                        onClick={(e) => {
                          e.preventDefault();
                          download(e, {
                            file_id: file.file_id || file.Id,
                            file_name: file.filename || file.file_name,
                          });
                        }}
                        className="ml-1 text-blue-600 hover:underline"
                        rel="noopener noreferrer"
                      >
                        {file.filename || file.file_name}
                      </a>
                      <button
                        type="button"
                        className="ml-2 text-red-500 hover:text-red-700"
                        style={{ border: "none" }}
                        onClick={() =>
                          removeAttachment(file.file_id || file.Id)
                        }
                      >
                        x
                      </button>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      <br />
      <div
        className="mr-auto"
        style={{ display: "flex", flexDirection: "row", alignItems: "center" }}
      >
        <button
          type="submit"
          className="btn btn-primary-blue btn-rounded btn-small mr-1"
          onClick={sendInvite}
        >
          SEND
        </button>

        <div className="file-icons flex items-center gap-3 ml-2 mt-2">
          <label title="Attach Files">
            <input
              type="file"
              accept=".jpg,.jpeg,.png,.gif,.bmp,.webp,.pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.rtf,.mp4,.mov,.webm,.avi"
              hidden
              multiple
              onChange={handleFileChange}
            />
            <i className="fa fa-paperclip cursor-pointer text-purple-600 text-lg"></i>
          </label>
        </div>
      </div>
    </form>
  );
};

export default EmailComposer;